module.exports = __webpack_public_path__ + "static/media/corporate-services-img51.273e53ff.jpg";